import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
    text-align: center;
}
`;